export default __webpack_public_path__ + "static/media/landing.00eeb1ed.svg";